<template>
    <div>
        <div class="row">
            <div class="col-lg-12">
                <h3 class="mb-0 text-uppercase">Personal Details</h3>
                <hr class="my-4" />
            </div>

            <div class="col-lg-8">
                <span class="text-uppercase">
                    <strong>Application Status: </strong>
                    <badge
                        :type="(applicant.status == 'awaiting-posting') ? 'success' : 'warning'"
                        v-if="applicant"
                    >
                        {{ (applicant.status == 'awaiting-posting') ? 'Added to Posting List' : applicant.status }}
                    </badge>
                    <br>
                </span>
                <span class="text-uppercase">
                    <strong>Application Date:</strong> {{ applicant.reg_date | getDateFormat }}
                </span><br>
                <span class="text-uppercase" v-if="(applicant.status == 'rejected' || applicant.status == 'awaiting-posting')">
                    <strong>{{ applicant.status }} Date:</strong> {{ applicant.approved_date | getDateFormat }}
                    <br>
                </span>
 
                <span class="text-uppercase" v-if="applicant && applicant.batch">
                    <strong>Attachment Program Batch:</strong> 
                    {{ applicant.batch.name + ' ' + applicant.batch.code + ' (' + applicant.batch.year + ')' }}
                </span><br>

                <span class="text-uppercase" v-if="applicant.attachment_centre_id">
                    <strong>Training Status: </strong>
                    <badge
                        :type="(applicant.status == 'awaiting-payment') ? 'success' : 'warning'"
                        v-if="applicant"
                    >
                        {{ replaceAll(applicant.training_status, '-', ' ') }}
                    </badge>
                    <hr>
                </span>
                
                <span class="text-uppercase">
                    <strong>Posting Status: </strong>
                    <badge
                        :type="(applicant.attachment_centre_id == null) ? 'warning' : 'success'"
                        v-if="applicant"
                    >
                        {{ (applicant.attachment_centre_id == null) ? 'Awaiting Posting' : 'Posted' }}
                    </badge>
                </span>
                <hr>
                <span class="text-uppercase">
                    <strong>Training Type:</strong> {{ applicant.training_type + ' Training'}}
                </span><hr>
                <span v-if="(applicant.status == 'rejected')">
                    <strong>Reject Reason:</strong> {{ applicant.reject_reason }}
                    <hr>
                </span>
            </div>

            <div class="col-lg-4 text-right">
                <img :src="photo" class="photo-class"/>
                <br><br>
            </div>

            <div class="table-responsive">

                <table class="table table-bordered">
                    <tbody>
                        <td>
                            <h4>RRR</h4>
                        </td>
                        <td colspan="2">
                            <h4 class="text-capitalize font-weight-light">
                                {{ rrr ? rrr : 'N/A' }}
                            </h4>
                        </td>
                        <td>
                            <h4>Training Type</h4>
                        </td>
                        <td colspan="2">
                            <h4 class="text-capitalize font-weight-light">
                                {{ applicant.training_type ? (applicant.training_type + ' Training') : 'N/A' }}
                            </h4>
                        </td>
                    </tbody>
                    <tbody>
                        <td>
                            <h4>Surname</h4>
                        </td>
                        <td>
                            <h4 class="text-capitalize font-weight-light">
                                {{ personal.surname ? personal.surname : 'N/A' }}
                            </h4>
                        </td>
                        <td>
                            <h4>First Name</h4>
                        </td>
                        <td>
                            <h4 class="text-capitalize font-weight-light">
                                {{ personal.first_name ? personal.first_name : 'N/A' }}
                            </h4>
                        </td>
                        <td>
                            <h4>Other Name</h4>
                        </td>
                        <td>
                            <h4 class="text-capitalize font-weight-light">
                                {{ personal.other_name ? personal.other_name : 'N/A' }}
                            </h4>
                        </td>
                    </tbody>
                    <tbody>
                        <td>
                            <h4>Previous Name</h4>
                        </td>
                        <td>
                            <h4 class="text-capitalize font-weight-light">
                                {{ personal.previous_name ? personal.previous_name : 'N/A' }}
                            </h4>
                        </td>
                        <td>
                            <h4>Gender</h4>
                        </td>
                        <td>
                            <h4 class="text-capitalize font-weight-light">
                                {{ personal.gender ? personal.gender : 'N/A' }}
                            </h4>
                        </td>
                        <td>
                            <h4>Marital Status</h4>
                        </td>
                        <td>
                            <h4 class="text-capitalize font-weight-light">
                                {{ personal.marital_status ? personal.marital_status : 'N/A' }}
                            </h4>
                        </td>
                    </tbody>
                    <tbody>
                        <td>
                            <h4>Date of Birth</h4>
                        </td>
                        <td>
                            <h4 class="text-capitalize font-weight-light">
                                {{ personal.date_of_birth | getDateFormat }}
                            </h4>
                        </td>
                        <td>
                            <h4>Place of Birth</h4>
                        </td>
                        <td>
                            <h4 class="text-capitalize font-weight-light">
                                {{ personal.place_of_birth ? personal.place_of_birth : 'N/A' }}
                            </h4>
                        </td>
                        <td>
                            <h4>Nationality</h4>
                        </td>
                        <td>
                            <h4 class="text-capitalize font-weight-light">
                                {{ personal.has_country ? personal.has_country.name : 'N/A' }}
                            </h4>
                        </td>
                    </tbody>
                    <tbody>
                        <td v-if="personal.nationality == 164">
                            <h4>State of Origin</h4>
                        </td>
                        <td v-if="personal.nationality == 164">
                            <h4 class="text-capitalize font-weight-light">
                                {{ personal.has_state ? personal.has_state.name : 'N/A' }}
                            </h4>
                        </td>
                        <td v-if="personal.nationality == 164">
                            <h4>LGA of Origin</h4>
                        </td>
                        <td v-if="personal.nationality == 164">
                            <h4 class="text-capitalize font-weight-light">
                                {{ personal.has_lga ? personal.has_lga.name : 'N/A' }}
                            </h4>
                        </td>
                        <td v-if="personal.nationality != 164">
                            <h4>State / Province</h4>
                        </td>
                        <td v-if="personal.nationality != 164">
                            <h4 class="text-capitalize font-weight-light">
                                {{ personal.foreign_state ? personal.foreign_state : 'N/A' }}
                            </h4>
                        </td>
                        <td>
                            <h4>Home Town</h4>
                        </td>
                        <td>
                            <h4 class="text-capitalize font-weight-light">
                                {{ personal.home_town ? personal.home_town : 'N/A' }}
                            </h4>
                        </td>
                    </tbody>
                    <tbody>
                        <td>
                            <h4>Permanent Home Address</h4>
                        </td>
                        <td colspan="5">
                            <h4 class="text-capitalize font-weight-light">
                                {{ personal.permanent_address ? personal.permanent_address : 'N/A' }}
                            </h4>
                        </td>
                    </tbody>
                    <tbody>
                        <td>
                            <h4>Residential Address in Nigeria</h4>
                        </td>
                        <td colspan="5">
                            <h4 class="text-capitalize font-weight-light">
                                {{ personal.residential_address ? personal.residential_address : 'N/A' }}
                            </h4>
                        </td>
                    </tbody>
                    <tbody v-if="personal.business_address">
                        <td>
                            <h4>Full Business Address</h4>
                        </td>
                        <td colspan="5">
                            <h4 class="text-capitalize font-weight-light">
                                {{ personal.business_address ? personal.business_address : 'N/A' }}
                            </h4>
                        </td>
                    </tbody>
                    <tbody>
                        <td>
                            <h4>Contact Address</h4>
                        </td>
                        <td colspan="5">
                            <h4 class="text-capitalize font-weight-light">
                                {{ personal.contact_address ? personal.contact_address : 'N/A' }}
                            </h4>
                        </td>
                    </tbody>
                    <tbody>
                        <td v-if="personal.nationality == 164">
                            <h4>Date of Return to Nigeria</h4>
                        </td>
                        <td v-if="personal.nationality == 164">
                            <h4 class="text-capitalize font-weight-light">
                                {{ personal.return_date | getDateFormat }}
                            </h4>
                        </td>
                        <td v-if="personal.nationality != 164">
                            <h4>Date of Entry into Nigeria</h4>
                        </td>
                        <td v-if="personal.nationality != 164">
                            <h4 class="text-capitalize font-weight-light">
                                {{ personal.entry_date | getDateFormat }}
                            </h4>
                        </td>
                        <td>
                            <h4>Phone Number</h4>
                        </td>
                        <td>
                            <h4 class="text-capitalize font-weight-light">
                                {{ personal.phone ? personal.phone : 'N/A' }}
                            </h4>
                        </td>
                        <td>
                            <h4>Email Address</h4>
                        </td>
                        <td>
                            <h4 class="font-weight-light">
                                {{ personal.email ? personal.email : 'N/A' }}
                            </h4>
                        </td>
                    </tbody>
                    <tbody>
                        <td>
                            <h4>Professional Experiences</h4>
                        </td>
                        <td colspan="5">
                            <h4 
                                class="text-capitalize font-weight-light"
                                v-html="breakWord(personal.professional_experiences, 150)"
                            >
                            </h4>
                        </td>
                    </tbody>
                    <tbody>
                        <td>
                            <h4>Employment Status</h4>
                        </td>
                        <td colspan="2">
                            <h4 class="text-capitalize font-weight-light">
                                {{ personal.employ_status ? personal.employ_status : 'N/A' }}
                            </h4>
                        </td>
                        <td>
                            <h4>Epic ID</h4>
                        </td>
                        <td colspan="2">
                            <h4 class="text-capitalize font-weight-light">
                                {{ personal.epic_id ? personal.epic_id : 'N/A' }}
                            </h4>
                        </td>
                    </tbody>
                </table>
            </div>
            <div class="col-lg-12">
                <hr class="my-4" />
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';

    export default {
        name: 'PersonalDetails',
        props: [ 'applicant', 'rrr', 'photo', 'breakWord' ],
        filters: {
            getDateFormat(value) {
                return value ? moment(value).format('Do MMM, YYYY') : 'N/A';
            }
        },
        computed: {
            personal() {
                return this.applicant.personal_data
            }
        }
    }
</script>

<style scoped>
    .no-padding-bottom {
        padding-bottom: 0rem !important
    }
    .right {
        float: right !important;
    }
    .photo-class {
        width: 200px;
        height: 200px;
    }
</style>

<style>
    .form-control-label {
        width: 100%;
    }
    .height-50 {
        height: 50px;
    }
    .borderLine {
        border: 1px solid #ededed;
    }
</style>